<div class="aside-editor" (click)="edit()" [ngClass]="{'editor-focus': !content}">
    <i class="aside-icon aside-icon--top icon icon--edit-text" [ngClass]="{'icon-hide': content}"></i>

    <div class="aside-content" [innerHTML]="content || placeholder | safe:'html'"></div>
</div>

<msc-aside-course *ngIf="display" [(content)]="content" [title]="title" [plugins]="plugins" (onUpdate)="update()" (onClose)="close()"></msc-aside-course>
